var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goods_line_bottom"},[_c('div',{staticClass:"tabs_content"},[_c('ul',[_c('li',{staticClass:"active"},[_vm._v("商品促销")]),_vm._v(" "),_c('li',{on:{"click":_vm.promotionjump}},[_vm._v("满减满送")])])]),_vm._v(" "),_c('GoodsList',{attrs:{"type":_vm.type}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a194378","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/promotion/promotion.vue
// module id = null
// module chunks = 